import { z } from 'zod'

import {
  type EvaluationTab,
  LOST_STATUSES,
  OPEN_STATUSES,
  type PipelineStatus,
  TABS,
} from './labels'
import type { EvaluationSort } from './queries'

const SORTS = [
  '-appraised_at',
  'appraised_at',
  'year',
  '-year',
  'make',
  '-make',
  'customer',
  '-customer',
  'mileage_km',
  '-mileage_km',
] as const satisfies readonly EvaluationSort[]

/** Newest first. */
export const DEFAULT_SORT: EvaluationSort = '-appraised_at'

const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined)

/**
 * The list's search: the tab, the filters, the sort and the page, in the address so a view can be
 * bookmarked or shared. Anything unreadable is dropped rather than refused, which leaves the
 * default.
 */
export const evaluationsSearchSchema = z.object({
  tab: z
    .enum(TABS.map((tab) => tab.key) as [EvaluationTab, ...EvaluationTab[]])
    .optional()
    .catch(undefined),
  appraiser: z.string().uuid().optional().catch(undefined),
  status: z
    .enum([...OPEN_STATUSES, ...LOST_STATUSES] as [PipelineStatus, ...PipelineStatus[]])
    .optional()
    .catch(undefined),
  from: day,
  to: day,
  q: z.string().max(100).optional().catch(undefined),
  sort: z.enum(SORTS).optional().catch(undefined),
  page: z.coerce.number().int().min(1).optional().catch(undefined),
})

export type EvaluationsSearch = z.output<typeof evaluationsSearchSchema>
